import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';

import Hotspot from './Hotspot';

import {
  getSidebarCurrentRoute,
  isArchive,
} from '../helpers/App';
import {
  userCanSeeLikes,
  userHasCap,
  userIsAdmin,
  userIsManager,
} from '../helpers/Auth';
import { getSetting } from '../helpers/Settings';
import { getCurrentURLParams } from '../helpers/URLParams';

const SidebarShort = ({ secondSidebarOpen, location }) => {
  const intl = useIntl();

  const currentSidebarRoute = getSidebarCurrentRoute(location);

  if (secondSidebarOpen) return null;

  return (
    <>
      <NavItem
        tag="div"
        id="sidebar-short-files"
        className={classnames('btn-link-common', { active: currentSidebarRoute === 'files' })}
      >
        <NavLink
          tag={Link}
          to={`${isArchive() ? '/archive' : ''}/files${location.pathname === '/files' ? getCurrentURLParams(location) : ''}`}
        >
          {isArchive() ? <i className="far fa-file-image" /> : <i className="far fa-file" />}
        </NavLink>
      </NavItem>
      <UncontrolledTooltip fade={false} placement="bottom" target="sidebar-short-files">
        {getSetting('cs1') ? (
          <>
            {isArchive() ?
              intl.formatMessage({ defaultMessage: 'All Archived Images' }) :
              intl.formatMessage({ defaultMessage: 'Recent Images' })}
          </>
        ) : (
          <>
            {isArchive() ?
              intl.formatMessage({ defaultMessage: 'All Archived Files' }) :
              intl.formatMessage({ defaultMessage: 'All Files' })}
          </>
        )}
      </UncontrolledTooltip>
      <NavLink
        tag={Link}
        id="sidebar-short-collections"
        to={`${isArchive() ? '/archive' : ''}/collections${window.location.pathname === '/collections' || window.location.pathname === '/archive' ? getCurrentURLParams(location) : ''}`}
        className={classnames('btn-link-common', { active: currentSidebarRoute === 'collections' })}
      >
        <i className="far fa-layer-group" />
      </NavLink>
      <UncontrolledTooltip fade={false} placement="bottom" target="sidebar-short-collections">
        {getSetting('cs1') ? (
          intl.formatMessage({ defaultMessage: 'Browse Categories' })
        ) : (
          intl.formatMessage({ defaultMessage: 'All Collections' })
        )}
      </UncontrolledTooltip>
      {userHasCap('my_collections') && (
        <>
          <NavLink
            tag={Link}
            id="sidebar-short-my-collections"
            to={`${isArchive() ? '/archive' : ''}/collections/my`}
            className={classnames('btn-link-common', { active: currentSidebarRoute === 'my-collections' })}
          >
            <i className="far fa-bookmark" />
          </NavLink>
          <UncontrolledTooltip fade={false} placement="bottom" target="sidebar-short-my-collections">
            {intl.formatMessage({ defaultMessage: 'My Collections' })}
          </UncontrolledTooltip>
        </>
      )}
      {userCanSeeLikes() && (
        <>
          <NavItem
            tag="div"
            id="sidebar-short-favorites"
            className={classnames('btn-link-common', { active: currentSidebarRoute === 'favorites' })}
          >
            <NavLink
              tag={Link}
              to="/favorites"
            >
              <i className="far fa-star" />
            </NavLink>
          </NavItem>
          <UncontrolledTooltip fade={false} placement="bottom" target="sidebar-short-favorites">
            {intl.formatMessage({ defaultMessage: 'My Favorites' })}
          </UncontrolledTooltip>
        </>
      )}
      {!getSetting('sidebar_hide_people') && (
        <>
          <NavItem
            tag="div"
            id="sidebar-short-people"
            className={classnames('btn-link-common', { active: currentSidebarRoute === 'people' })}
          >
            <NavLink
              tag={Link}
              to="/people"
            >
              <i className="far fa-user-viewfinder" style={{ position: 'relative' }}>
                <Hotspot id="people-sidebar" />
              </i>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip fade={false} placement="bottom" target="sidebar-short-people">
            {intl.formatMessage({ defaultMessage: 'People' })}
          </UncontrolledTooltip>
        </>
      )}
      {(userIsAdmin() || userIsManager()) && (
        <>
          <NavItem
            tag="div"
            id="sidebar-content-portals"
            className={classnames('btn-link-common', { active: currentSidebarRoute === 'pages' })}
          >
            <NavLink
              tag={Link}
              to="/admin/pages"
            >
              <i className="far fa-table-layout" />
            </NavLink>
          </NavItem>
          <UncontrolledTooltip fade={false} placement="bottom" target="sidebar-content-portals">
            {intl.formatMessage({ defaultMessage: 'Content Portals' })}
          </UncontrolledTooltip>
        </>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  secondSidebarOpen: state.App.secondSidebarOpen,
});

SidebarShort.propTypes = {
  location: PropTypes.object.isRequired,
  secondSidebarOpen: PropTypes.bool.isRequired,
};

export default withRouter(connect(mapStateToProps)(SidebarShort));
